import { DrawPhotoNumber } from "./photo-number-module";
import { angles } from "./photo-number-icons";
import { DrawingModuleContainer } from "../../ModuleBase/DrawingModuleContainer";
import { html } from "lit-element";

export class DrawPhotoNumberContainer extends DrawingModuleContainer {
	constructor(canvas) {
		super(canvas);

		this.moduleId = "photoNumbers";
		this.toolbarWidth = "60px";
		this.label = "Photo Numbers";

		const iconStyle = html`
            <style>
                .mtb-photo-number-icon svg {
                    width: 28px;
                }
                .mtb-photo-number-icon text {
                    fill: var(--primary-color-variant1) !important;
                }
                .mtb-photo-number-icon path {
                    stroke: var(--primary-color-variant1) !important;
                }
            </style>`;
		const icon = angles["e"]();
		this.icon = html`<span class="mtb-photo-number-icon">${iconStyle} ${icon}</span>`;
		
		this.submodules.push(new DrawPhotoNumber(this.canvas, "n"));
		this.submodules.push(new DrawPhotoNumber(this.canvas, "s"));
		this.submodules.push(new DrawPhotoNumber(this.canvas, "w"));
		this.submodules.push(new DrawPhotoNumber(this.canvas, "e"));
		this.submodules.push(new DrawPhotoNumber(this.canvas, "ne"));
		this.submodules.push(new DrawPhotoNumber(this.canvas, "nw"));
		this.submodules.push(new DrawPhotoNumber(this.canvas, "se"));
		this.submodules.push(new DrawPhotoNumber(this.canvas, "sw"));
	}
}
window.customElements.define("inspx-draw-photo-number-container", DrawPhotoNumberContainer);
